import CryptoJS from 'crypto-js';

const Encodenew = () => {
  function encryptPayload(payload) {
    const plaintext = JSON.stringify(payload);
    const secretKeyHex = process.env.REACT_APP_SECRET_VALUE;
    const ivHex = process.env.REACT_APP_SECRET_VALUE;

    if (!secretKeyHex || !ivHex) {
      throw new Error("Environment variables are not set correctly.");
    }

    const key = CryptoJS.enc.Hex.parse(secretKeyHex);
    const iv = CryptoJS.enc.Hex.parse(ivHex);

    const encrypted = CryptoJS.AES.encrypt(plaintext, key, { iv: iv });
    const encryptedBase64 = encrypted.toString();

    console.log('Encrypted Data (Base64):', encryptedBase64);

    return encodeURIComponent(encryptedBase64); // ✅ return string only
  }

  return { encryptPayload };
};

export default Encodenew;
